<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div class="container-fluid">
    <div class="row h-100">
      <Sidebar></Sidebar>
      <div class="col-sm p-0">
        <div class="manageshipment">
          <div class="container-fluid h-100 p-0">
            <div
              class="manageshipment__mastercontent"
              style="height: calc(100vh - 110px) !important"
            >
              <div class="pt-2 manageshipment__wrapper2">
                <router-link
                  :to="{
                    name: 'inventoryList',
                    params: { type: $route.params.type }
                  }"
                  class="d-flex align-items-center mb-5 mt-3"
                  style="text-decoration: none;color: #1D3354;"
                >
                  <img
                    class="mr-2"
                    src="@/assets/image/icon/cheveron-left.svg"
                  />
                  Back
                </router-link>
                <div class="text-center" v-if="isLoadingInventoryDetail">
                  <b-spinner label="Loading..."></b-spinner>
                </div>
                <div v-else class="pdetail__border p-4 mb-5">
                  <div
                    v-if="
                      $route.params.type === 'in-storage' &&
                        inventoryDetail.isRequestOutStorage
                    "
                    class="p-3 d-flex align-items-center justify-content-center bg-info-surface w-100"
                  >
                    <span class="text-sm text-info-main font-weight-bolder">
                      Your request is in the process of awaiting approval from
                      the Andalin team
                    </span>
                  </div>
                  <div class="row m-0 mb-4">
                    <button
                      class="menutabs"
                      :class="selectedtabs === tab.router ? 'menuactive' : ''"
                      v-for="tab in tabs"
                      :key="tab.id"
                      @click="changeTab(tab.router)"
                    >
                      <p class="text-center">{{ tab.title }}</p>
                    </button>
                  </div>
                  <div v-if="selectedtabs === 'detail'">
                    <div
                      class="d-flex align-items-center justify-content-between pdetail__header mb-3 mt-2"
                    >
                      <p>Inbound Info</p>
                      <p>Inbound ID : {{ form.inboundId || '-' }}</p>
                    </div>
                    <div class="d-flex mb-2">
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">Warehouse</p>
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="form.warehouse"
                            :options="warehouseList || []"
                            placeholder="Select warehouse"
                            label="name"
                            :select-label="''"
                            :deselect-label="''"
                            name="Warehouse"
                            disabled
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/arrow-down-full-blue.svg"
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">Inbound Date</p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.dateInbound"
                              type="date"
                              name="Inbound Date"
                              :min="getDate(new Date())"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex mb-2">
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">
                          Total SKU
                        </p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              :value="listSkuFiltered.length"
                              type="number"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">
                          Total Inbound Quantity
                        </p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.totalStorageQuantity"
                              type="number"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex mb-2">
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">
                          Reference Number (Optional)
                        </p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.referenceNumber"
                              name="Reference Number"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">
                          Nomor Pengajuan (Optional)
                        </p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.nomorPengajuan"
                              name="Nomor Pengajuan"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex mb-2">
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">Master AWB</p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.mawb"
                              type="text"
                              name="Inbound awb"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">House AWB</p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.hawb"
                              type="text"
                              name="Inbound hawb"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex mb-2">
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">Master BL</p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.mbl"
                              type="text"
                              name="Inbound bl"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">House BL</p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.hbl"
                              type="text"
                              name="Inbound hbl"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex mb-2">
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">
                          Storage Area (in m2)
                        </p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.sqty"
                              type="text"
                              name="Inbound hawb"
                              disabled
                            />
                          </b-input-group>
                          <p class="paragraphmini">
                            This section will be soon updated by the operator
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- Out Storage Details -->
                    <div
                      v-if="$route.params.type === 'out-storage'"
                      class="my-3 table-responsive"
                    >
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <p class="pdetail__header mb-3 mt-2">
                          Out Storage Details
                        </p>
                        <button
                          class="bluewhite"
                          style="width: 186px"
                          :disabled="isLoadingDownloadOutStorageReport"
                          @click="downloadOutStorageReport()"
                        >
                          <div
                            v-if="isLoadingDownloadOutStorageReport"
                            class="spinner-border"
                            role="status"
                            style="
                              width: 1rem !important;
                              height: 1rem !important;
                            "
                          >
                            <span class="sr-only">Loading...</span>
                          </div>
                          <span v-else>Download Out Storage Details</span>
                        </button>
                      </div>
                      <table class="table table-borderless">
                        <thead>
                          <tr class="titleTable">
                            <th scope="col">Outbond Date</th>
                            <th scope="col">Outbond ID</th>
                            <th scope="col">SKU ID</th>
                            <th scope="col">Out Qty</th>
                            <th scope="col">Remaining Qty</th>
                            <th scope="col">Document</th>
                            <th scope="col">Notes</th>
                          </tr>
                        </thead>
                        <tbody
                          v-if="
                            inventoryDetail &&
                              inventoryDetail.outStorage &&
                              inventoryDetail.outStorage.length > 0
                          "
                          style="background-color: #EBF1FF;"
                        >
                          <tr
                            v-for="data in outStorageGroupByOutboundId"
                            :key="data.id"
                            class="paragraphTable"
                          >
                            <td>{{ data.outbound_date }}</td>
                            <td style="word-break: break-all;">
                              {{ data.outbound_id }}
                            </td>
                            <td style="word-break: break-all;">
                              {{ data.sku_id }}
                            </td>
                            <td>
                              {{
                                Number(data.outbound_quantity).toLocaleString()
                              }}
                            </td>
                            <td>
                              {{ Number(data.final_quantity).toLocaleString() }}
                            </td>
                            <td>
                              <template
                                v-if="data.t_inventory_files.length > 0"
                              >
                                <p
                                  v-for="(file,
                                  index) in data.t_inventory_files"
                                  :key="index"
                                  class="cursor-pointer hover-underline"
                                  @click="downloadFileInventory(file)"
                                >
                                  {{ file.original_name }}
                                </p>
                              </template>
                              <span v-else>-</span>
                            </td>
                            <td>{{ data.notes }}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td class="text-sm italic">
                              No Out Storage Details
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div v-else-if="selectedtabs === 'sku-list'">
                    <!-- filter -->
                    <div
                      class="d-flex justify-content-between align-items-center mb-3"
                    >
                      <p class="pdetail__header">SKU Information</p>
                      <div class="d-flex p-2">
                        <div class="d-flex align-items-center pr-2">
                          <span style="font-size: 14px">Filter By</span>
                        </div>
                        <div
                          class="options__multiselect d-flex align-items-center"
                        >
                          <multiselect
                            v-model="selected"
                            :options="filterOptions"
                            placeholder="Select"
                            selectedLabel=""
                            label="text"
                            :select-label="''"
                            :deselect-label="''"
                            @input="filterChoice"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                        </div>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-if="
                                !['All', 'Out Storage Request'].includes(
                                  selected.text
                                )
                              "
                              v-model="searchItem"
                              class="ml-3"
                              :placeholder="`Input ${selected.text}`"
                              style="height: 37px"
                              type="text"
                            />
                          </b-input-group>
                        </div>
                      </div>
                    </div>
                    <template
                      v-if="
                        $route.params.type === 'in-storage' &&
                          !isLoadingInventoryDetail
                      "
                    >
                      <div class="d-flex align-items-center mb-3">
                        <div
                          v-if="
                            inventoryDetail &&
                              inventoryDetail.isRequestOutStorage
                          "
                          class="bg-neutral-50 text-white text-xs shadow-sm d-flex align-items-center justify-content-center"
                          style="font-weight: 600; height: 36px; line-height: 24px; border-radius: 4px; padding: 1px 6px;"
                        >
                          Request Move to Out Storage
                        </div>
                        
                        <button
                          v-else
                          class="bluewhite"
                          :disabled="disabledRequestToMove"
                          style="width: fit-content;"
                          @click="handleClickRequestToMove()"
                        >
                          {{this.selectSkuActive ? 'Process to Move' : 'Request Move to Out Storage'}}
                        </button>
                        <button
                          v-if="selectSkuActive"
                          class="button__whiteblueborder ml-2"
                          @click="selectSkuActive = false"
                        >
                          Cancel
                        </button>
                      </div>
                    </template>
                    <template v-if="!isLoadingInventoryDetail">
                      <p class="text-sm mb-3" style="color: #7e7e7e">
                        Showing Total <b>{{ listSkuFiltered.length }} SKU ID</b>
                      </p>
                      <template v-if="selectSkuActive">
                        <div id="checkbox-all-sku" class="mb-4">
                          <div class="d-flex align-items-center">
                            <input
                              v-model="allSkuSelected"
                              class="checkbox-sku"
                              type="checkbox"
                              style="margin-left: 14px;"
                              @change="toggleAll"
                            />
                            <p class="ml-3 text-sm font-semibold text-7a7c7e">
                              {{
                                allSkuSelected
                                  ? 'Un-Select All'
                                  : 'Select All "SKU"'
                              }}
                            </p>
                          </div>
                          <p class="text-sm font-semibold text-7a7c7e">
                            {{ selectedSku.length }} SKU Selected
                          </p>
                        </div>
                        <div
                          v-for="(item, index) in listSkuFiltered"
                          :key="item.id"
                          class="d-flex align-items-start"
                        >
                          <div
                            class="text-base font-semwibold text-1d3354 mr-3"
                          >
                            {{ index + 1 }}.
                          </div>
                          <div class="w-100 d-flex align-items-start">
                            <input
                              class="checkbox-sku"
                              type="checkbox"
                              :checked="isSelectedSku(item)"
                              :id="'flexCheckDefault' + index"
                              @change="handleSelectSku(item)"
                            />

                            <div class="bg-card-list mb-3 ml-3">
                              <div class="row">
                                <div class="col-md-2 pr-0 pb-3">
                                  <div
                                    class="d-flex flex-column align-center h-100 justify-content-center"
                                  >
                                    <img
                                      :src="item.img"
                                      :alt="`sku-image-${item.id}`"
                                      style="border-radius: 8px"
                                      class="w-100"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-10 pl-0">
                                  <div class="d-flex flex-column pl-4 mb-3">
                                    <span class="font-bold text-1d3354">{{
                                      item.productInformation || '-'
                                    }}</span>

                                    <div
                                      class="d-flex gap-2 justify-content-between"
                                    >
                                      <div
                                        class="d-flex gap-2 align-items-center text-sm"
                                      >
                                        <div class="d-flex gap-2">
                                          <span class="text-muted"
                                            >Inbound Quantity</span
                                          >
                                          <span
                                            class="text-1d3354 font-semibold"
                                            >{{
                                              item.quantity.toLocaleString() ||
                                                '-'
                                            }}</span
                                          >
                                        </div>
                                        |
                                        <div
                                          class="d-flex gap-2 align-items-center"
                                        >
                                          <span class="text-muted"
                                            >In-Storage Quantity</span
                                          >
                                          <span
                                            clas="text-1d3354 font-semibold"
                                            >{{
                                              item.instorageQuantity.toLocaleString() ||
                                                '-'
                                            }}</span
                                          >
                                        </div>
                                        |
                                        <div
                                          class="d-flex gap-2 align-items-center"
                                        >
                                          <span class="text-muted"
                                            >Out-Storage Quantity</span
                                          >
                                          <span
                                            class="text-1d3354 font-semibold"
                                            >{{
                                              item.outstorageQuantity.toLocaleString() ||
                                                '-'
                                            }}</span
                                          >
                                        </div>
                                      </div>

                                      <div v-if="!selectAllFilter">
                                        <div class="input__model1group">
                                          <p class="text-sm text-6e6e6e mr-2">
                                            Input Outbound Quantity
                                          </p>
                                          <b-form-input
                                            type="number"
                                            placeholder="E.g: 1-1000"
                                            :name="
                                              `Out Storage Quantity ${index}`
                                            "
                                            v-model="item.outboundQuantity"
                                            v-validate="{
                                              required: true,
                                              min_value: 1
                                            }"
                                            trim
                                            min="0"
                                            @keypress="avoidMinus($event)"
                                            @paste="avoidPasteMinus($event)"
                                          ></b-form-input>
                                          <p
                                            v-if="
                                              item.formOutStorageQuantity &&
                                                item.formOutStorageQuantity >
                                                  item.instorageQuantity
                                            "
                                            class="fontstyle__errormsg"
                                          >
                                            Out storage quantity could not be
                                            larger than in storage quantity
                                          </p>
                                          <p
                                            v-if="
                                              errors.has(
                                                `Out Storage Quantity ${i}`
                                              )
                                            "
                                            class="fontstyle__errormsg"
                                          >
                                            {{
                                              errors.first(
                                                `Out Storage Quantity ${i}`
                                              )
                                            }}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row w-100">
                                    <!-- col 1 -->
                                    <div
                                      class="col-md-6 col text-1d3354 border-right border-e1e1e1"
                                    >
                                      <div class="d-flex align-items-start">
                                        <div class="ml-4 w-100">
                                          <div
                                            class="d-flex p-0 align-items-start mb-2"
                                          >
                                            <p
                                              class="text-sm text-6e6e6e"
                                              style="width: 120px"
                                            >
                                              SKU ID
                                            </p>
                                            <p
                                              class="d-flex align-items-start text-sm"
                                            >
                                              <span class="mr-1">:</span>
                                              <span class="font-semibold">{{
                                                item.skuId || '-'
                                              }}</span>
                                            </p>
                                          </div>
                                          <div
                                            class="d-flex p-0 align-items-start mb-2"
                                          >
                                            <p
                                              class="text-sm text-6e6e6e"
                                              style="width: 120px"
                                            >
                                              HS Code
                                            </p>
                                            <p
                                              class="d-flex align-items-start text-sm"
                                            >
                                              <span class="mr-1">:</span>
                                              <span class="font-semibold">{{
                                                item.hsCode || '-'
                                              }}</span>
                                            </p>
                                          </div>
                                          <div
                                            class="d-flex p-0 align-items-start mb-2"
                                          >
                                            <p
                                              class="text-sm text-6e6e6e"
                                              style="width: 120px"
                                            >
                                              Gross Weight
                                            </p>
                                            <p
                                              class="d-flex align-items-start text-sm"
                                            >
                                              <span class="mr-1">:</span>
                                              <span class="font-semibold">{{
                                                item.weight
                                                  ? parseFloat(
                                                      item.weight
                                                    ).toLocaleString() + ' kg'
                                                  : '-'
                                              }}</span>
                                            </p>
                                          </div>
                                          <div
                                            class="d-flex p-0 align-items-start mb-2"
                                          >
                                            <p
                                              class="text-sm text-6e6e6e"
                                              style="width: 120px"
                                            >
                                              Nett Weight
                                            </p>
                                            <p
                                              class="d-flex align-items-start text-sm"
                                            >
                                              <span class="mr-1">:</span>
                                              <span class="font-semibold">{{
                                                item.nettWeight
                                                  ? parseFloat(
                                                      item.nettWeight
                                                    ).toLocaleString() + ' kg'
                                                  : '-'
                                              }}</span>
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- col 2 -->
                                    <div class="col-md-6 col text-1d3354 pl-4">
                                      <div
                                        class="d-flex p-0 align-items-start mb-2"
                                      >
                                        <p
                                          class="text-sm text-6e6e6e"
                                          style="width: 120px"
                                        >
                                          Country of Origin
                                        </p>
                                        <p
                                          class="d-flex align-items-start text-sm"
                                        >
                                          <span class="mr-1">:</span>
                                          <span class="font-semibold">{{
                                            item.countryOrigin || '-'
                                          }}</span>
                                        </p>
                                      </div>
                                      <div
                                        class="d-flex p-0 align-items-start mb-2"
                                      >
                                        <p
                                          class="text-sm text-6e6e6e"
                                          style="width: 120px"
                                        >
                                          Item Number
                                        </p>
                                        <p
                                          class="d-flex align-items-start text-sm"
                                        >
                                          <span class="mr-1">:</span>
                                          <span class="font-semibold">{{
                                            item.itemNumber || '-'
                                          }}</span>
                                        </p>
                                      </div>
                                      <div
                                        class="d-flex p-0 align-items-start mb-2"
                                      >
                                        <p
                                          class="text-sm text-6e6e6e"
                                          style="width: 120px"
                                        >
                                          CIF
                                        </p>
                                        <p
                                          class="d-flex align-items-start text-sm"
                                        >
                                          <span class="mr-1">:</span>
                                          <span class="font-semibold">{{
                                            item.cif || '-'
                                          }}</span>
                                        </p>
                                      </div>
                                      <div
                                        class="d-flex p-0 align-items-start mb-2"
                                      >
                                        <p
                                          class="text-sm text-6e6e6e"
                                          style="width: 120px"
                                        >
                                          Packaging Type
                                        </p>
                                        <p
                                          class="d-flex align-items-start text-sm"
                                        >
                                          <span class="mr-1">:</span>
                                          <span class="font-semibold">{{
                                            item.packagingType || '-'
                                          }}</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="w-100 d-flex pr-0 align-items-start mb-2 mt-2"
                              >
                                <p
                                  class="text-sm text-6e6e6e"
                                  style="width: 120px"
                                >
                                  Notes
                                </p>
                                <p
                                  class="text-sm text-1d3354 d-flex align-items-start"
                                  style="width: calc(100% - 120px)"
                                >
                                  <span class="mr-1">:</span>
                                  <span
                                    class="font-semibold"
                                    v-html="item.notes || '-'"
                                  />
                                </p>
                              </div>
                              <div
                                class="d-flex align-items-start mt-2 border-top mt-3 pt-3"
                                v-if="item.fileName && item.fileName.length > 0"
                              >
                                <p
                                  class="pdetail__paragraph1 d-flex"
                                  style="min-width: 156px"
                                >
                                  <span>Uploaded Document</span
                                  ><span class="px-2">:</span>
                                </p>
                                <div
                                  class="d-flex align-items-center"
                                  style="flex-wrap: wrap"
                                >
                                  <div
                                    class="pdetail__paragraph2"
                                    v-for="(file, i) in item.fileName"
                                    :key="i"
                                  >
                                    <p
                                      class="d-flex"
                                      @click="downloadSku(item, file)"
                                      style="
                                  text-decoration: underline !important;
                                  cursor: pointer;
                                "
                                    >
                                      <span>{{ file ? file.name : '' }}</span>
                                      <span class="px-2">{{
                                        i != item.fileName.length - 1 ? ',' : ''
                                      }}</span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          v-for="(item, index) in listSkuFiltered"
                          :key="item.id"
                          class="d-flex align-items-start"
                        >
                          <div class="text-base font-semibold text-1d3354 mr-3">
                            {{ index + 1 }}.
                          </div>
                          <div class="bg-card-list mb-3 position-relative">
                            <!-- blue badge absolute -->
                            <div
                              v-if="
                                $route.params.type === 'in-storage' &&
                                  item.isRequestOutStorage
                              "
                              class="d-flex align-items-center justify-content-end position-absolute"
                              style="top: 0; right: 0"
                            >
                              <div
                                class="bg-info-main px-3 py-2 d-flex align-items-center justify-content-center"
                                style="border-radius: 0px 8px 0px"
                              >
                                <span
                                  class="text-xs font-weight-bold italic text-white"
                                >
                                  Out Storage Request
                                </span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-2 pr-0 pb-3">
                                <div
                                  class="d-flex flex-column align-center h-100 justify-content-center"
                                >
                                  <img
                                    :src="item.img"
                                    :alt="`sku-image-${item.id}`"
                                    style="border-radius: 8px"
                                    class="w-100"
                                  />
                                </div>
                              </div>
                              <div class="col-md-10 pl-0">
                                <div class="d-flex flex-column pl-4 mb-3">
                                  <span class="font-bold text-1d3354">{{
                                    item.productInformation || '-'
                                  }}</span>

                                  <div
                                    class="d-flex gap-2 justify-content-between"
                                  >
                                    <div
                                      class="d-flex gap-2 align-items-center text-sm"
                                    >
                                      <div class="d-flex gap-2">
                                        <span class="text-muted"
                                          >Inbound Quantity</span
                                        >
                                        <span
                                          class="text-1d3354 font-semibold"
                                          >{{
                                            item.quantity.toLocaleString() ||
                                              '-'
                                          }}</span
                                        >
                                      </div>
                                      |
                                      <div
                                        class="d-flex gap-2 align-items-center"
                                      >
                                        <span class="text-muted"
                                          >In-Storage Quantity</span
                                        >
                                        <span
                                          clas="text-1d3354 font-semibold"
                                          >{{
                                            item.instorageQuantity.toLocaleString() ||
                                              '-'
                                          }}</span
                                        >
                                      </div>
                                      |
                                      <div
                                        class="d-flex gap-2 align-items-center"
                                      >
                                        <span class="text-muted"
                                          >Out-Storage Quantity</span
                                        >
                                        <span
                                          class="text-1d3354 font-semibold"
                                          >{{
                                            item.outstorageQuantity.toLocaleString() ||
                                              '-'
                                          }}</span
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row w-100">
                                  <!-- col 1 -->
                                  <div
                                    class="col-md-6 col text-1d3354 border-right border-e1e1e1"
                                  >
                                    <div class="d-flex align-items-start">
                                      <div class="ml-4 w-100">
                                        <div
                                          class="d-flex p-0 align-items-start mb-2"
                                        >
                                          <p
                                            class="text-sm text-6e6e6e"
                                            style="width: 120px"
                                          >
                                            SKU ID
                                          </p>
                                          <p
                                            class="d-flex align-items-start text-sm"
                                          >
                                            <span class="mr-1">:</span>
                                            <span class="font-semibold">{{
                                              item.skuId || '-'
                                            }}</span>
                                          </p>
                                        </div>
                                        <div
                                          class="d-flex p-0 align-items-start mb-2"
                                        >
                                          <p
                                            class="text-sm text-6e6e6e"
                                            style="width: 120px"
                                          >
                                            HS Code
                                          </p>
                                          <p
                                            class="d-flex align-items-start text-sm"
                                          >
                                            <span class="mr-1">:</span>
                                            <span class="font-semibold">{{
                                              item.hsCode || '-'
                                            }}</span>
                                          </p>
                                        </div>
                                        <div
                                          class="d-flex p-0 align-items-start mb-2"
                                        >
                                          <p
                                            class="text-sm text-6e6e6e"
                                            style="width: 120px"
                                          >
                                            Gross Weight
                                          </p>
                                          <p
                                            class="d-flex align-items-start text-sm"
                                          >
                                            <span class="mr-1">:</span>
                                            <span class="font-semibold">{{
                                              item.weight
                                                ? parseFloat(
                                                    item.weight
                                                  ).toLocaleString() + ' kg'
                                                : '-'
                                            }}</span>
                                          </p>
                                        </div>
                                        <div
                                          class="d-flex p-0 align-items-start mb-2"
                                        >
                                          <p
                                            class="text-sm text-6e6e6e"
                                            style="width: 120px"
                                          >
                                            Nett Weight
                                          </p>
                                          <p
                                            class="d-flex align-items-start text-sm"
                                          >
                                            <span class="mr-1">:</span>
                                            <span class="font-semibold">{{
                                              item.nettWeight
                                                ? parseFloat(
                                                    item.nettWeight
                                                  ).toLocaleString() + ' kg'
                                                : '-'
                                            }}</span>
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- col 2 -->
                                  <div class="col-md-6 col text-1d3354 pl-4">
                                    <div
                                      class="d-flex p-0 align-items-start mb-2"
                                    >
                                      <p
                                        class="text-sm text-6e6e6e"
                                        style="width: 120px"
                                      >
                                        Country of Origin
                                      </p>
                                      <p
                                        class="d-flex align-items-start text-sm"
                                      >
                                        <span class="mr-1">:</span>
                                        <span class="font-semibold">{{
                                          item.countryOrigin || '-'
                                        }}</span>
                                      </p>
                                    </div>
                                    <div
                                      class="d-flex p-0 align-items-start mb-2"
                                    >
                                      <p
                                        class="text-sm text-6e6e6e"
                                        style="width: 120px"
                                      >
                                        Item Number
                                      </p>
                                      <p
                                        class="d-flex align-items-start text-sm"
                                      >
                                        <span class="mr-1">:</span>
                                        <span class="font-semibold">{{
                                          item.itemNumber || '-'
                                        }}</span>
                                      </p>
                                    </div>
                                    <div
                                      class="d-flex p-0 align-items-start mb-2"
                                    >
                                      <p
                                        class="text-sm text-6e6e6e"
                                        style="width: 120px"
                                      >
                                        CIF
                                      </p>
                                      <p
                                        class="d-flex align-items-start text-sm"
                                      >
                                        <span class="mr-1">:</span>
                                        <span class="font-semibold">{{
                                          item.cif || '-'
                                        }}</span>
                                      </p>
                                    </div>
                                    <div
                                      class="d-flex p-0 align-items-start mb-2"
                                    >
                                      <p
                                        class="text-sm text-6e6e6e"
                                        style="width: 120px"
                                      >
                                        Packaging Type
                                      </p>
                                      <p
                                        class="d-flex align-items-start text-sm"
                                      >
                                        <span class="mr-1">:</span>
                                        <span class="font-semibold">{{
                                          item.packagingType || '-'
                                        }}</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="w-100 d-flex pr-0 align-items-start mb-2 mt-2"
                            >
                              <p
                                class="text-sm text-6e6e6e"
                                style="width: 120px"
                              >
                                Notes
                              </p>
                              <p
                                class="text-sm text-1d3354 d-flex align-items-start"
                                style="width: calc(100% - 120px)"
                              >
                                <span class="mr-1">:</span>
                                <span
                                  class="font-semibold"
                                  v-html="item.notes || '-'"
                                />
                              </p>
                            </div>
                            <div
                              class="d-flex align-items-start mt-2 border-top mt-3 pt-3"
                              v-if="item.fileName && item.fileName.length > 0"
                            >
                              <p
                                class="pdetail__paragraph1 d-flex"
                                style="min-width: 156px"
                              >
                                <span>Uploaded Document</span
                                ><span class="px-2">:</span>
                              </p>
                              <div
                                class="d-flex align-items-center"
                                style="flex-wrap: wrap"
                              >
                                <div
                                  class="pdetail__paragraph2"
                                  v-for="(file, i) in item.fileName"
                                  :key="i"
                                >
                                  <p
                                    class="d-flex"
                                    @click="downloadSku(item, file)"
                                    style="
                                  text-decoration: underline !important;
                                  cursor: pointer;
                                "
                                  >
                                    <span>{{ file ? file.name : '' }}</span>
                                    <span class="px-2">{{
                                      i != item.fileName.length - 1 ? ',' : ''
                                    }}</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </div>

                  <div v-else-if="selectedtabs === 'document'">
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr class="titleTable">
                            <th scope="col">Date and Time</th>
                            <th scope="col">File Name</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody
                          v-if="
                            inventoryDetail &&
                              inventoryDetail.documents &&
                              inventoryDetail.documents.length > 0
                          "
                        >
                          <tr
                            v-for="data in inventoryDetail.documents"
                            :key="data.id"
                            class="paragraphTable"
                          >
                            <td>{{ getDateTime(data.created_at) }}</td>
                            <td>{{ data.name }}</td>
                            <td>
                              <div class="d-flex items-center">
                                <button
                                  class="d-flex align-items-center justify-content-center button__whiteblueborder mr-2"
                                  style="min-width: 144px; font-size: 12px !important"
                                  @click="downloadFileInventory(data)"
                                >
                                  <div
                                    v-if="
                                      selectedDocument.id &&
                                        selectedDocument.id == data.id &&
                                        isLoadingDownloadFileInventory
                                    "
                                    class="spinner-border"
                                    role="status"
                                    style="
                                      width: 1rem !important;
                                      height: 1rem !important;
                                    "
                                  >
                                    <span class="sr-only">Loading...</span>
                                  </div>
                                  <span v-else>Download</span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td style="font-size: 14px">
                              No Document Available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div v-else class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr class="titleTable">
                          <th scope="col">Date and Time</th>
                          <th scope="col">Update By</th>
                          <th scope="col">Activity</th>
                        </tr>
                      </thead>
                      <tbody
                        v-if="inventoryHistory && inventoryHistory.length > 0"
                      >
                        <tr
                          v-for="data in inventoryHistory"
                          :key="data.id"
                          class="paragraphTable"
                        >
                          <td>{{ getDateTime(data.created_at) }}</td>
                          <td>{{ data.c_user.fullname }}</td>
                          <td v-html="data.activity" />
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td style="font-size: 14px;font-style: italic;">
                            This inbound does not have any updated history
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modals">
      <ModalInfo
        :openModal.sync="dataModalInfo.show"
        :dataModal="dataModalInfo"
      />
      <MoveOutStorageModal
        :viewModal.sync="modalMoveOutStorage"
        :selectedSku.sync="selectedSku"
        @handle-result="handleResultMoveStorage($event)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Sidebar from '@/components/global/Sidebar.vue'
import ModalSKU from '@/components/global/modals/modalAddSKU.vue'
import MoveOutStorageModal from '../../../components/global/modals/MoveOutStorageModal.vue'
import ModalInfo from '../../../components/global/modals/ModalInfo.vue'
export default {
  name: 'detail',
  components: {
    ModalSKU,
    Sidebar,
    MoveOutStorageModal,
    ModalInfo
  },
  data() {
    return {
      form: {
        inboundId: '',
        warehouse: '',
        dateInbound: '',
        totalStorageQuantity: '',
        referenceNumber: '',
        nomorPengajuan: '',
        mawb: '',
        hawb: '',
        mbl: '',
        hbl: '',
        slocation: '',
        sqty: ''
      },
      id: '',
      selectedtabs: 'detail',
      selectedDocument: { id: null },
      selectedSku: [],
      allSkuSelected: false,
      selectSkuActive: false,
      modalMoveOutStorage: false,
      listSku: [],
      tabs: [
        {
          id: 1,
          title:
            this.$route.params.type === 'in-storage'
              ? 'In-Storage Details'
              : 'Out-Storage Details',
          router: 'detail'
        },
        {
          id: 2,
          title: 'SKU List',
          router: 'sku-list'
        },
        {
          id: 3,
          title: 'Document',
          router: 'document'
        },
        {
          id: 4,
          title: 'History',
          router: 'history'
        }
      ],
      dataModalInfo: {
        show: false,
        text: '',
        img: require('@/assets/image/icon/checklist-success.svg'),
        typeModal: 'INFO', // CONFIRM (button yes & no), INFO (button ok)
        buttons: null
      },
      filterOptions:
        this.$route.params.type === 'in-storage'
          ? [
              { text: 'All', value: '' },
              { text: 'SKU ID', value: 'skuId' },
              { text: 'Product Name', value: 'productInformation' },
              { text: 'Item Number', value: 'itemNumber' },
              { text: 'Country of Origin', value: 'countryOrigin' },
              { text: 'HS Code', value: 'hsCode' },
              { text: 'Out Storage Request', value: 'outStorageRequest' },
              { text: 'Notes', value: 'notes' }
            ]
          : [
              { text: 'All', value: '' },
              { text: 'SKU ID', value: 'skuId' },
              { text: 'Product Name', value: 'productInformation' },
              { text: 'Item Number', value: 'itemNumber' },
              { text: 'Country of Origin', value: 'countryOrigin' },
              { text: 'HS Code', value: 'hsCode' },
              { text: 'Notes', value: 'notes' }
            ],
      selected: {
        text: 'All',
        value: ''
      },
      searchItem: ''
    }
  },
  computed: {
    ...mapGetters({
      warehouseList: 'warehouse/warehouseList',
      isLoadingWarehouseList: 'warehouse/isLoadingWarehouseList',
      errorWarehouseList: 'warehouse/errorWarehouseList',

      inventoryDetail: 'warehouse/inventoryDetail',
      isLoadingInventoryDetail: 'warehouse/isLoadingInventoryDetail',
      errorInventoryDetail: 'warehouse/errorInventoryDetail',

      inventoryHistory: 'warehouse/inventoryHistory',
      isLoadingInventoryHistory: 'warehouse/isLoadingInventoryHistory',
      errorInventoryHistory: 'warehouse/errorInventoryHistory',

      isLoadingDownloadFileInventory:
        'warehouse/isLoadingDownloadFileInventory',

      isLoadingDownloadOutStorageReport:
        'warehouse/isLoadingDownloadOutStorageReport',
      errorDownloadOutStorageReport: 'warehouse/errorDownloadOutStorageReport'
    }),
    disabledRequestToMove() {
      return this.selectSkuActive && this.selectedSku.length == 0
    },
    outStorageGroupByOutboundId() {
      if (this.inventoryDetail && this.inventoryDetail.outStorage.length > 0) {
        const reduced = this.inventoryDetail.outStorage.reduce(
          (accumulator, current) => {
            ;(accumulator[current.outbound_id] =
              accumulator[current.outbound_id] || []).push(current)
            return accumulator
          },
          {}
        )
        let result = []
        Object.keys(reduced).forEach(outboundId => {
          reduced[outboundId].forEach((item, index) => {
            let tempDetail = {}
            if (index == 0) {
              tempDetail = { ...item }
            } else {
              tempDetail = {
                ...item,
                ...{
                  outbound_date: '',
                  outbound_id: '',
                  t_inventory_files: '',
                  notes: ''
                }
              }
            }
            result.push(tempDetail)
          })
        })
        return result
      } else {
        return []
      }
    },
    listSkuFiltered() {
      if (this.listSku.length != 0) {
        if (this.$route.params.type === 'in-storage') {
          const result = this.listSku.filter(el => el.instorageQuantity != 0)
          return result
        }
        return this.listSku
      }
      return []
    }
  },
  watch: {
    searchItem(value) {
      this.searchItem = value
      const lengthVar = value.length
      // eslint-disable-next-line consistent-return
      setTimeout(() => {
        if (lengthVar !== this.searchItem.length) {
          return false
        }
        this.fetchInventoryDetail()
      }, 1000)
    }
  },
  async mounted() {
    await this.init()
  },
  methods: {
    toggleAll() {
      this.selectedSku = this.allSkuSelected ? this.listSkuFiltered : []
    },
    async init() {
      await this.$store.dispatch('warehouse/FETCH_WAREHOUSE_LIST')
      await this.fetchInventoryDetail()
      await this.$store.dispatch(
        'warehouse/INVENTORY_HISTORY',
        this.$route.params.id
      )
    },
    getOutboundQuantity(el) {
      if (this.selectedSku.length > 0) {
        const selected = this.selectedSku.find(item => item.id == el.id)
        if (selected) {
          return selected.outboundQuantity
            ? Number(selected.outboundQuantity)
            : null
        }
      }
      return null
    },
    async fetchInventoryDetail() {
      this.listSku = []
      let filter = ''
      if (this.selected.value) {
        filter = `${this.selected.value}=${
          this.selected.value === 'outStorageRequest' ? '1' : this.searchItem
        }`
        filter += `&type=${this.$route.params.type}`
      }
      await this.$store
        .dispatch('warehouse/FETCH_INVENTORY_DETAIL', {
          id: this.$route.params.id,
          filter
        })
        .then(() => {
          if (this.inventoryDetail) {
            const warehouse = this.warehouseList.find(
              el => el.id == this.inventoryDetail.warehouseId
            )
            this.form = {
              inboundId: this.inventoryDetail.inboundId || '-',
              dateInbound: this.inventoryDetail.inboundDate,
              warehouse: warehouse || null,
              totalStorageQuantity: Number(this.inventoryDetail.quantity),
              referenceNumber: this.inventoryDetail.referenceNumber,
              nomorPengajuan: this.inventoryDetail.nomorPengajuan,
              mawb: this.inventoryDetail.masterAwb,
              hawb: this.inventoryDetail.houseAwb,
              mbl: this.inventoryDetail.masterBl || '',
              hbl: this.inventoryDetail.houseBl || '',
              slocation: this.inventoryDetail.storageLocation,
              sqty: Number(this.inventoryDetail.storageQuantity)
            }
            this.listSku = this.inventoryDetail.sku.map(el => ({
              id: el.id,
              img:
                el.pictureUrl || require('@/assets/image/empty-sku-image.png'),
              skuId: el.skuId,
              productInformation: el.productInformation,
              companyName: this.inventoryDetail.companyName,
              inboundDate: this.inventoryDetail.inboundDate,
              packagingType: el.packagingType,
              itemNumber: el.itemNumber,
              hsCode: el.hsCode,
              weight: Number(el.weight),
              nettWeight: Number(el.nettWeight),
              cif: el.cif,
              countryOrigin: el.countryOrigin,
              notes: el.notes,
              fileName: el.files,
              dataFoto: el.filePicture[0],
              isRequestOutStorage: el.isRequestOutStorage,
              instorageQuantity: Number(el.instorageQuantity),
              outstorageQuantity: Number(el.outstorageQuantity),
              quantity: Number(el.quantity),
              outboundQuantity: this.getOutboundQuantity(el)
            }))
          }
        })
    },
    filterChoice() {
      if (['All', 'Out Storage Request'].includes(this.selected.text)) {
        setTimeout(() => {
          this.fetchInventoryDetail()
        }, 300)
      }
    },
    downloadSku(data1, data2) {
      const skuId = data1.id
      const fileId = data2.id
      const fileName = data2.original_name
      this.$store.dispatch('warehouse/DOWNLOAD_SKU', {
        skuId,
        fileId,
        fileName
      })
    },

    downloadFileInventory(data) {
      this.selectedDocument = data
      const fileId = data.id
      const fileName = data.original_name
      this.$store
        .dispatch('warehouse/DOWNLOAD_FILE_INVENTORY', {
          fileId,
          fileName,
          url: null,
          type: data.type || 'inventory'
        })
        .then(() => {
          if (this.errorDownloadFileInventory) {
            this.dataModalInfo.text = 'Failed'
            this.dataModalInfo.img = require('@/assets/image/icon/failed.svg')
            this.dataModalInfo.show = true
          }
        })
    },

    downloadOutStorageReport() {
      const fileName = `${this.inventoryDetail.inboundId}_${moment().format(
        'YYYY/MM/DD'
      )}_Out Storage Details Report`
      this.$store
        .dispatch('warehouse/DOWNLOAD_OUT_STORAGE_REPORT', {
          id: this.$route.params.id,
          fileName
        })
        .then(() => {
          if (this.errorDownloadOutStorageReport) {
            this.dataModalInfo.text = 'Failed'
            this.dataModalInfo.img = require('@/assets/image/icon/failed.svg')
            this.dataModalInfo.show = true
          }
        })
    },
    changeTab(item) {
      this.selectedtabs = item
    },
    getDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    getDateTime(date) {
      return moment(date).format('DD/MM/YYYY hh:mm A')
    },
    handleResultMoveStorage(status) {
      if (status) {
        this.dataModalInfo.text = 'Your request has been sent'
        this.dataModalInfo.img = require('@/assets/image/icon/checklist-success.svg')
        setTimeout(() => {
          this.$router
            .push({
              name: 'inventoryList',
              params: { type: 'in-storage' }
            })
            .then(() => {})
        }, 3000)
      } else {
        this.dataModalInfo.text = 'Failed to sent request!'
        this.dataModalInfo.img = require('@/assets/image/icon/failed.svg')
      }
      this.dataModalInfo.show = true
    },
    handleClickRequestToMove() {
      if (!this.selectSkuActive) {
        this.selectSkuActive = true
      } else {
        this.modalMoveOutStorage = true
      }
    },
    avoidMinus(e) {
      // eslint-disable-next-line no-restricted-globals
      const key = !isNaN(e.charCode) ? e.charCode : e.keyCode
      if (!this.keyAllowed(key)) e.preventDefault()
    },
    avoidPasteMinus(e) {
      const pasteData = e.clipboardData.getData('text/plain')
      if (pasteData.match(/[^0-9]/)) e.preventDefault()
    },
    keyAllowed(key) {
      const keys = [
        8,
        9,
        13,
        16,
        17,
        18,
        19,
        20,
        27,
        46,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        91,
        92,
        93
      ]
      if (key && keys.indexOf(key) === -1) return false
      return true
    },
    handleSelectSku(item) {
      const selected = this.selectedSku.find(el => el.id == item.id)
      if (selected) {
        this.selectedSku = this.selectedSku.filter(el => el.id !== item.id)
        if (this.allSkuSelected) {
          this.allSkuSelected = false
        }
      } else {
        this.selectedSku.push(item)
      }
    },
    isSelectedSku(item) {
      const selected = this.selectedSku.find(el => el.id == item.id)
      return selected ? true : false
    }
  }
}
</script>

<style lang="scss">
.checkbox-sku {
  -ms-transform: scale(1.5); /* IE */
  -moz-transform: scale(1.5); /* FF */
  -webkit-transform: scale(1.5); /* Safari and Chrome */
  -o-transform: scale(1.5); /* Opera */
  transform: scale(1.5);
}
#checkbox-all-sku {
  background-color: #ebf1ff;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sku-image-wrapper {
  background-position: center;
  background-size: cover;
  width: 109px;
  height: 82px;
  background-repeat: no-repeat;
}
.bg-card-list {
  border-radius: 8px;
  width: 100%;
  padding: 32px 16px 20px;
  border: 1px solid var(--neutral-100, #f5f6f7);
  background: var(--base-white, #fff);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06),
    0px 1px 3px 0px rgba(16, 24, 40, 0.1);
}
.pdetail {
  &__header {
    font-size: 16px;
    font-weight: 700;
    color: #1d3354;
    @media only screen and (max-width: 1536px) {
      margin: 1.5rem 0rem 0.5rem 0rem !important;
    }
  }
  &__paragraph1 {
    font-size: 14px;
    font-weight: 400;
    color: #6e6e6e;
  }
  &__paragraph2 {
    font-size: 14px;
    font-weight: 600;
    color: #1d3354;
  }
  &__border {
    border: 1px solid #dadee2;
    border-radius: 8px;
    @media only screen and (min-width: 1536px) {
      padding: 1.5rem;
    }
    padding: 1rem;
    column-gap: 1rem;
  }
  &__buttonwhite {
    width: 185px;
    height: 36px;
    color: #1d3354;
    border: 1px solid #1d3354;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.011em;
  }
  &__buttonred {
    width: 100px;
    height: 36px;
    color: #c4232a;
    border: 1px solid #c4232a;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.011em;
  }
}
#checkboxAir {
  font-size: 14px !important;
  color: #686868 !important;
}
.titleTable {
  background: #1d3354;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}
.paragraphTable {
  color: #1d3354;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.paragraphmini {
  color: var(--neutral-60, #9ea1a4) !important;
  /* Text M/Regular */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
  letter-spacing: -0.072px;
}
.alert {
  font-size: 14px;
  font-weight: 600;
}
.menutabs {
  color: var(--neutral-50, #bec2c5);
  text-align: center;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  border: none;
  padding: 0px 15px;
  height: 44px;
  font-size: 14px;
  background-color: transparent;
  outline: none !important;
}
.menuactive {
  color: #1d3354;
  font-weight: 700;
  border-bottom: 2px solid #1d3354;
}
.customplaceholder {
  ::placeholder {
    color: #9ea1a4 !important;
  }

  @media only screen and (min-width: 1536px) {
    width: 100%;
  }

  width: 73%;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouse/inventoryList/detail.vue